import React from 'react';
import UserBar from '../../main/containers/bmc/UserBar';
import ChatContainer from '../../main/containers/chat';

export default function Container({
  title,
  locales,
  children,
  withChat = false,
}) {
  return (
    <div className="bmc-canvas-container">
      <div className="bmc-canvas-menu">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <a href="/" className="bmc-canvas-menu-logo">
          <i className="icon-logo" />
        </a>
      </div>

      <div className="bmc-canvas-container-block">
        <div className="bmc-canvas-container-block-top">
          <div className="bmc-canvas-container-block-title">{title}</div>
          <UserBar locales={locales} />
        </div>

        <div className="bmc-canvas-container-block-content">
          {withChat && (
            <section
              className="bmc-canvas-container-block-section__chat"
              aria-label="Messaging"
            >
              <ChatContainer />
            </section>
          )}
          <section
            className="bmc-canvas-container-block-section__content"
            aria-label="Portfolio"
          >
            <div className="admin-main">{children}</div>
          </section>
        </div>
      </div>
    </div>
  );
}
